import {SOPutInvoice} from '../../core/invoice/so-put-invoice';
import {InvoiceCore} from './invoice.core';
import {SOGetInvoice} from '../../core/invoice/so-get-invoice';
import {FormField, SelectionOption} from 'lionheartland';
import {putInvoiceFormFieldOptions} from './put-invoice-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {SubscriptionCore} from '../subscription/subscription.core';
import {SOGetSubscription} from '../../core/subscription/so-get-subscription';

export class RAPutInvoice extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putInvoiceFormFieldOptions);

  RequestClass = SOPutInvoice

  constructor(
    public entityCore: InvoiceCore
  ) {
    super();
    if (putInvoiceFormFieldOptions.subscription) {
      putInvoiceFormFieldOptions.subscription.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('ref'),
      this.getFormValueFromIdentifier('exRef'),
      this.getFormValueFromIdentifier('amountDue'),
      this.getFormValueFromIdentifier('amountPaid'),
      this.getFormValueFromIdentifier('amountRemaining'),
      this.getFormValueFromIdentifier('dateDue'),
      this.getFormValueFromIdentifier('periodStart'),
      this.getFormValueFromIdentifier('periodEnd'),
      this.getFormValueFromIdentifier('paid'),
      this.getFormValueFromIdentifier(
        'subscription',
        SOGetSubscription,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}